<template>
    <v-list class="pa-0" style="margin-left: 20px; margin-right: 20px;">
        <v-list-item class="pl-0 pr-0">
            <v-list-item-content class="pt-0 pb-0">{{keyText}}</v-list-item-content>
            <strong>
                <v-list-item-content class="align-end">{{value}}</v-list-item-content>
            </strong>
        </v-list-item>
        <v-divider ></v-divider>
    </v-list>
</template>

<script>
    export default {
        name: "ListItemDetailHorizontal",
        props: {
            keyText: {
                type: [String, Number, Boolean],
                default: false
            },
            value: {
                type: [String, Number, Boolean],
                default: false
            },
            divider: {
                type: [Boolean],
                default: false
            },
        },
        methods: {}
    }
</script>

